/**
 * custom-seo-clean.js
 * Extrait de theme.liquid — comportement de survol du menu desktop (header-menu details)
 * Non critique : n'affecte ni panier, ni checkout, ni variantes produit
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-menu details').forEach((menu) => {
    menu.addEventListener('mouseenter', () => {
      if (window.innerWidth > 990) {
        menu.setAttribute('open', true);
      }
    });

    menu.addEventListener('mouseleave', () => {
      if (window.innerWidth > 990) {
        menu.removeAttribute('open');
      }
    });
  });
});
